import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Tab,
} from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext, TabList } from "@mui/lab";

import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import FeedbackIcon from '@mui/icons-material/Feedback';
import RequestFeedback from "./RequestFeedback";
import FeedbackList, { FeedbackListSkeleton } from "./FeecbackList";
import Popup from "../../../Base/views/Popup";
import { useDispatch, useSelector } from "react-redux";
import { DeletePmsFeedbackAction, GetPmsFeedbackAction, UpdatePmsFeedbackAction } from "../../../../../store/Employee/PMSFeedback/Action";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import MyFeedback from "./MyFeedback/MyFeedback";
import { getUserData, isAdminOwner } from "../../../Base/helper/baseFunctions";
import history from "../../../../../history";

export default function FeedBack() {
  const [requestpopup, setRequestpopup] = useState(false);
  const [value, setValue] = useState(isAdminOwner() ? "1" : "2");
  const [replyLoading, setReplyLoading] = useState(true);
  const userData = getUserData();
  const today = new Date();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const dispatch = useDispatch();
  const {pmsFeedbackLoading, feedbackData} = useSelector(
        (state) => state?.EmployeeReducer?.PmsFeedbackReducer
      );
  const [currentFeedback, setCurrentFeedback] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [feedbackType, setFeedbackType] = useState(null);
  const closeMode = () => {
      setRequestpopup(false);
      setCurrentFeedback(null);
      setOpenDialog(false);
      setFeedbackType(null);
    };
  const handleFeedback = (type) => {
    setRequestpopup(true);
    setFeedbackType(type);
  }
    const handleFeedbackPopup = (currentData, actionType) => {
      if(actionType === "Edit"){
        setRequestpopup(true);
      }
      if(actionType === "Delete"){
        setOpenDialog(true);
      }
      setCurrentFeedback(currentData);
    }
  const handleReplyAdd = (feedback, replyMsg) => {
    if(feedback?.feedback_pk) {
      setReplyLoading(false);
      dispatch(
          UpdatePmsFeedbackAction({...feedback,
            replyToast: true,
            feedback_type: {value: feedback?.feedback_type},
            feedback_json: JSON.stringify([
              {
                from: userData?.name,
                message: replyMsg,
                date: `${today.getFullYear()}-${("0" + (today.getMonth() + 1)).slice(-2)}-${("0" + today.getDate()).slice(-2)}`,
              },
             ...(
                Array.isArray(feedback?.feedback_json) 
                  ? feedback.feedback_json 
                  : typeof feedback?.feedback_json === "string" 
                    ? JSON.parse(feedback.feedback_json) 
                    : []
              ),
          ]),
          }, (error, result) => {
            setReplyLoading(true);
          })
        );
    }
  }
  const handleDeleteFeedback = () => {
    dispatch(DeletePmsFeedbackAction({feedback_pk: currentFeedback?.feedback_pk}))
    setOpenDialog(false);
    closeMode();
  }
  useEffect(() => {
    dispatch(GetPmsFeedbackAction());
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[value])
  return (
    <Box sx={{ height: "calc(100vh - 75px)", overflow: "hidden"}}>
      <Box
        sx={{
          position: "sticky",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <ArrowBackButton
          iconSize={18}
          onClick={() => {
            history.goBack();
          }}
        />
        <Typography
          sx={{
            fontFamily: "Nunito Sans",
            fontWeight: 700,
            color: "#000000",
            fontSize: "1.2rem",
          }}
        >
          FeedBack
        </Typography>
        <DashboardIcon fontSize="small" />
      </Box>
      <Box>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
            {isAdminOwner() && (<Tab
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <BookmarkBorderIcon style={{ verticalAlign: "middle" }} />{" "}
                    All Feedback
                  </div>
                }
                value="1"
              />)}
              <Tab
                label={
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <FeedbackIcon style={{ verticalAlign: "middle", fontSize: 22 }} />{" "}
                    My FeedBack
                  </div>
                }
                value="2"
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1.5,
                  height: 36,
                  mt: 0.5 ,
                  pr: 1,
                  width: "100%",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  size="small"
                  className="mpl-primary-btn"
                  onClick={() => {
                    handleFeedback("Give");
                  }}
                >
                  Give FeedBack
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  size="small"
                  className="mpl-primary-btn"
                  onClick={() => {
                    handleFeedback("Request");
                  }}
                >
                  Request FeedBack
                </Button>
              </Box>
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 1, height: "calc(100vh - 155px)", overflowY: "auto" }} >
              {(pmsFeedbackLoading && replyLoading) ? Array.from(new Array(3)).map((_, idx) => (
                      <FeedbackListSkeleton />
                  ))
                : feedbackData?.length > 0 ? (
                    <FeedbackList
                        feedbacks={feedbackData}
                        getTypeColor={getTypeColor}
                        onReply={(fb, replyMsg) => handleReplyAdd(fb, replyMsg)}
                        handleFeedbackPopup={handleFeedbackPopup}
                      />
                ) : (
                      <Box
                      sx={{
                        height: "40vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{ textAlign: "center", px: 2 }}
                      >
                        No Data Available
                      </Typography>
                    </Box>
                )}
              
          </TabPanel>
          <TabPanel value="2" sx={{ p: 1 }} >
            <MyFeedback feedbackData={feedbackData} getTypeColor={getTypeColor} handleFeedbackPopup={handleFeedbackPopup} pmsFeedbackLoading={pmsFeedbackLoading}/>
          </TabPanel>
        </TabContext>
      </Box>
      <Popup
        title={currentFeedback ? "Edit Feedback" : feedbackType === "Give" ? "Give Feedback" : feedbackType === "Request" ? "Request Feedback" : ""}
        openPopup={requestpopup}
        setOpenPopup={closeMode}
        fullWidth={true}
        maxWidth="sm"
      >
      <RequestFeedback
        setOpenPopup={setRequestpopup}
        closeMode={closeMode}
        currentFeedback={currentFeedback}
        feedbackType={feedbackType}
      />
      </Popup>
      <ConfirmationDialog
        title={"Delete Feedback"}
        content={"Are you sure you want to proceed?"}
        openDialog={openDialog}
        closeDialog={setOpenDialog}
        OkButtonText="Yes"
        onSubmit={handleDeleteFeedback}
      />
    </Box>
  );
}


const getTypeColor = (type) => {
  switch (type) {
    case "Positive":
      return "success";
    case "Constructive":
      return "warning";
    default:
      return "default";
  }
};